"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ColumnGroup = exports.RowGroup = void 0;
const styled_components_1 = __importStar(require("styled-components"));
const index_1 = require("./index");
const Group = styled_components_1.default.div `
  display: flex;
`;
exports.RowGroup = (0, styled_components_1.default)(Group) `
  justify-content: space-between;

  :first-child {
    flex-wrap: wrap;

    > div {
      width: auto;
      margin-bottom: ${({ theme }) => theme.space.s100};

      :last-child {
        a:not(:hover) {
          color: ${({ theme }) => theme.colors.gray.s700};
        }
      }
    }

    p {
      color: ${({ theme }) => theme.colors.gray.s700};

      ${({ theme }) => (0, styled_components_1.css)(theme.typography.body.boldSmallText)};
    }
  }

  :nth-child(2) {
    padding: ${({ theme }) => theme.space.s500} 0;
  }

  :nth-child(-n + 2) {
    border-bottom: 1px solid ${({ theme }) => theme.colors.gray.s300};
  }

  @media screen and (min-width: ${({ theme }) => theme.breakpoint.desktop}) {
    > * {
      width: ${({ length }) => 100 / length}%;

      :first-child {
        padding-left: 0;
      }

      :last-child {
        padding-right: 0;
      }
    }
  }

  @media screen and (max-width: ${({ theme }) => theme.breakpoint.desktop}) {
    flex-direction: ${({ mobileDirection }) => mobileDirection !== null && mobileDirection !== void 0 ? mobileDirection : 'row'};

    ${({ mobileDirection }) => mobileDirection === index_1.Direction.Column &&
    (0, styled_components_1.css) `
        > *:not(:first-child) {
          padding-top: ${({ theme }) => theme.space.s300};
        }
      `}
  }
`;
exports.ColumnGroup = (0, styled_components_1.default)(Group) `
  flex-direction: column;

  > *:not(:first-child) {
    padding-top: ${({ theme }) => theme.space.s300};
  }

  :nth-child(-n + 2) {
    border-bottom: 1px solid ${({ theme }) => theme.colors.gray.s300};
  }

  @media screen and (max-width: ${({ theme }) => theme.breakpoint.desktop}) {
    flex-direction: ${({ mobileDirection }) => mobileDirection !== null && mobileDirection !== void 0 ? mobileDirection : 'row'};
    padding-top: ${({ theme }) => theme.space.s400};
  }
`;
